import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const AddAttachmentIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 17 17">
    <path
      d="M11.8451 16.4999C9.45572 16.4999 7.51172 14.5559 7.51172 12.1666C7.51172 9.77726 9.45572 7.83325 11.8451 7.83325C14.2344 7.83325 16.1784 9.77726 16.1784 12.1666C16.1784 14.5559 14.2344 16.4999 11.8451 16.4999ZM11.8451 8.83325C10.0071 8.83325 8.51172 10.3286 8.51172 12.1666C8.51172 14.0046 10.0071 15.4999 11.8451 15.4999C13.6831 15.4999 15.1784 14.0046 15.1784 12.1666C15.1784 10.3286 13.6831 8.83325 11.8451 8.83325Z"
      fill={props.stroke}
      stroke="none"
    />
    <path
      d="M11.8477 14.4999C11.5717 14.4999 11.3477 14.2759 11.3477 13.9999V10.3333C11.3477 10.0573 11.5717 9.83325 11.8477 9.83325C12.1237 9.83325 12.3477 10.0573 12.3477 10.3333V13.9999C12.3477 14.2759 12.1237 14.4999 11.8477 14.4999Z"
      fill={props.stroke}
      stroke="none"
    />
    <path
      d="M13.6784 12.6667H10.0117C9.73572 12.6667 9.51172 12.4427 9.51172 12.1667C9.51172 11.8907 9.73572 11.6667 10.0117 11.6667H13.6784C13.9544 11.6667 14.1784 11.8907 14.1784 12.1667C14.1784 12.4427 13.9544 12.6667 13.6784 12.6667Z"
      fill={props.stroke}
      stroke="none"
    />
    <path
      d="M6.30635 14.5H2.01302C1.00169 14.5 0.179688 13.678 0.179688 12.6667V2.33333C0.179688 1.322 1.00169 0.5 2.01302 0.5H9.67969C10.691 0.5 11.513 1.322 11.513 2.33333V6.39333C11.513 6.66933 11.289 6.89333 11.013 6.89333C10.737 6.89333 10.513 6.66933 10.513 6.39333V2.33333C10.513 1.874 10.139 1.5 9.67969 1.5H2.01302C1.55369 1.5 1.17969 1.874 1.17969 2.33333V12.6667C1.17969 13.126 1.55369 13.5 2.01302 13.5H6.30635C6.58235 13.5 6.80635 13.724 6.80635 14C6.80635 14.276 6.58235 14.5 6.30635 14.5Z"
      fill={props.stroke}
      stroke="none"
    />
    <path
      d="M9.01303 6.83325H2.67969C2.40369 6.83325 2.17969 6.60925 2.17969 6.33325C2.17969 6.05725 2.40369 5.83325 2.67969 5.83325H9.01303C9.28903 5.83325 9.51303 6.05725 9.51303 6.33325C9.51303 6.60925 9.28903 6.83325 9.01303 6.83325Z"
      fill={props.stroke}
      stroke="none"
    />
    <path
      d="M6.34635 9.5H2.67969C2.40369 9.5 2.17969 9.276 2.17969 9C2.17969 8.724 2.40369 8.5 2.67969 8.5H6.34635C6.62235 8.5 6.84635 8.724 6.84635 9C6.84635 9.276 6.62235 9.5 6.34635 9.5Z"
      fill={props.stroke}
      stroke="none"
    />
    <path
      d="M5.67968 4.16675H2.67969C2.40369 4.16675 2.17969 3.94275 2.17969 3.66675C2.17969 3.39075 2.40369 3.16675 2.67969 3.16675H5.67968C5.95568 3.16675 6.17968 3.39075 6.17968 3.66675C6.17968 3.94275 5.95568 4.16675 5.67968 4.16675Z"
      fill={props.stroke}
      stroke="none"
    />
  </SvgIcon>
);
